import { combineReducers } from 'redux';

import atualizarParametroLocalidade from './atualizarParametroLocalidade/reducer';
import cadastrarParametroLocalidade from './cadastrarParametroLocalidade/reducer';
import consultarParametrosLocalidade from './consultarParametrosLocalidade/reducer';
import excluirParametroLocalidade from './excluirParametroLocalidade/reducer';
import consultarParametroLocalidadeDetalhe from './consultarParametroLocalidadeDetalhe/reducer';
import atualizarParametroLocalidadeDetalhe from './atualizarParametroLocalidadeDetalhe/reducer';
import consultarParametrosLocalidadeV2 from './consultarParametrosLocalidadeV2/reducer';
import consultarParametroLocalidadesSigla from './consultarParametroLocalidadesSigla/reducer';
import excluirParametrosLocalidade from './excluirParametrosLocalidade/reducer';

export default combineReducers({
	atualizarParametroLocalidade,
	cadastrarParametroLocalidade,
	consultarParametrosLocalidade,
	excluirParametroLocalidade,
	consultarParametroLocalidadeDetalhe,
	atualizarParametroLocalidadeDetalhe,
	consultarParametrosLocalidadeV2,
	consultarParametroLocalidadesSigla,
	excluirParametrosLocalidade,
});
